export const ACCOUNT_USERS_INDEX_TOUR = {
  id: "account_users_index",
  steps: [
    {
      element: '[data-tour="account-users-create"]',
      popover: {
        title: "Adicionar colaborador",
        description: "Convide pessoas da sua equipe e defina o nível de permissão de cada uma.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="account-users-list"]',
      popover: {
        title: "Colaboradores da conta",
        description: "Veja e-mail e permissão de cada colaborador com acesso a esta conta.",
        side: "top",
      },
    },
  ],
};
